module.exports = __webpack_public_path__ + "static/img/9.29d0734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/9.png
// module id = 138
// module chunks = 2